export default () => ({
  trackers: null,
})
